import * as React from 'react';
import { regions, countries, Country } from 'typed-countries';
import { BaseForm } from './Base';
import theme from '../../utils/theme';

const base = (visible: boolean) => {
  const opacity = visible ? 'o-75' : 'o-100';

  return `${theme.form.field.input} ${opacity}`;
};

type SelectProps = React.InputHTMLAttributes<HTMLSelectElement>;

export interface Props extends SelectProps {
  id: string;
  label: string;
  tooltip?: string;
  field: any;
  onValueChange: Function;
  defaultValue: any;
}

type RegionProps = {
  name: string;
  countries: Country[];
  onChange: Function;
  selectedCountries: string[];
};

const hasAll = (props: RegionProps) => {
  return (
    props.countries.filter(
      (country: Country) => !props.selectedCountries.includes(country.name),
    ).length === 0
  );
};
const setAll = (props: RegionProps, regionCountries: string[]) => {
  return Array.from(new Set(props.selectedCountries.concat(regionCountries)));
};
const setCountry = (name: string, props: RegionProps) => {
  return Array.from(new Set(props.selectedCountries.concat([name])));
};
const unsetCountry = (name: string, props: RegionProps) => {
  return props.selectedCountries.filter((item: string) => item !== name);
};
const filterAll = (props: RegionProps, regionCountries: string[]) => {
  return props.selectedCountries.filter(
    (item: string) => !regionCountries.includes(item),
  );
};

function RegionSelect(props: RegionProps) {
  const [visible, setVisible] = React.useState(false);
  const regionCountries = props.countries.map((country: Country) => country.name);

  return (
    <React.Fragment>
      <div className={base(visible)} onClick={() => setVisible(!visible)}>
        <input
          className="mr3"
          id={props.name}
          type="checkbox"
          name={props.name}
          onChange={(e) => {
            if (e.target.checked) {
              props.onChange(setAll(props, regionCountries));
            } else {
              props.onChange(filterAll(props, regionCountries));
            }
          }}
          defaultChecked={hasAll(props)}
        />
        {props.name}
      </div>
      {visible && (
        <div className="pl3 pl4-ns">
          {props.countries.map((country) => (
            <label htmlFor={country.iso} className={theme.form.field.input}>
              <input
                className="mr3"
                id={country.iso}
                type="checkbox"
                name={country.iso}
                onChange={(e) => {
                  if (e.target.checked) {
                    props.onChange(setCountry(country.name, props));
                  } else {
                    props.onChange(unsetCountry(country.name, props));
                  }
                }}
                defaultChecked={props.selectedCountries.includes(country.name)}
              />
              {country.name}
            </label>
          ))}
        </div>
      )}
    </React.Fragment>
  );
}

export default (props: Props) => {
  return (
    <BaseForm label={props.label} id={props.id} tooltip={props.tooltip}>
      {regions.map((item) => (
        <RegionSelect
          name={item}
          onChange={(territories: string[]) =>
            props.onValueChange(props.field, territories)
          }
          countries={countries.filter(
            (country) => String(country.region) === String(item),
          )}
          selectedCountries={props.defaultValue}
        />
      ))}
    </BaseForm>
  );
};
